<template>
  <div class="form-row d-info d-frame">
    <h3>karta podarunkowa Pyszne.pl <span v-if="amount">- {{ amount }} ZŁ</span></h3>
    <p>Wręcz kartę podarunkową tym, których kochasz. Nieważne, czy to prezent z okazji urodzin, podziękowanie czy po prostu wyraz sympatii. Kup kartę podarunkową i podaruj najbliższym jedzenie pod same drzwi Pyszne.pl.</p>
    <p>Naszą misją jest dostarczanie każdego dnia radości. W polsce współpracujemy z ponad 9500 restauracji, serwującymi od burgerów po sushi.</p>
    <p><a href="" @click.prevent="showMore = true" v-if="!showMore">więcej informacji</a></p>
    <div v-if="showMore">
      <h3>Instrukcja aktywacji:</h3>
      <ul class="decimal">
        <li>Wejdź na Pyszne.pl i wpisz swój kod pocztowy</li>
        <li>Wybieraj spośród tysięcy restauracji</li>
        <li>Dodaj do swojego koszyka ulubione pyszności i kontynuuj zamówienie</li>
        <li>W dolnej części ekranu kliknij „DODAJ KOD RABATOWY” i wpisz kod z karty podarunkowej</li>
        <li>Podczas realizacji transakcji wartość karty podarunkowej zostanie odjęta od sumy zamówienia</li>
        <li>To wszystko. Zrelaksuj się i zaczekaj, aż kurier dostarczy jedzenie!</li>
      </ul>
      <p>Kod można zrealizować w ciągu 1 roku od jego zakupu.</p>
      <h3>Zasady użytkowania:</h3>
      <p><a href="https://giftcards-pyszne.pl/pl_pl/terms-and-conditions" target="_blank" rel="nofollow">https://giftcards-pyszne.pl/pl_pl/terms-and-conditions</a></p>
      <p><a href="" @click.prevent="showMore = false">zwiń</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupCodesInfoJustEat',
  props: ['amount'],
  data () {
    return {
      showMore: false
    }
  }
}
</script>
